module.exports = __webpack_public_path__ + "static/media/ApiKuning.85d72a0a.svg";